<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Группы</div>
            </div>
            <div class="panel-body pn">
                <div class="dt-panelmenu">
                    <div class="filter-form">
                        <label>
                            Преподаватель
                            <select v-on:change="load" :disabled="isLoading" v-model="filter.trainer" class="form-control input-sm">
                                <option value="">Не выбран</option>
                                <option v-for="(trainer, index) in trainers" v-bind:key="index" :value="trainer.id">
                                    {{trainer.fullName}}
                                </option>
                            </select>
                        </label>
                        <label class="ml10">
                            Направление
                            <select v-on:change="load" :disabled="isLoading" v-model="filter.direction" class="form-control input-sm">
                                <option value="">Не выбрано</option>
                                <option v-for="(direction, index) in directions" v-bind:key="index" :value="direction.id">
                                    {{direction.name}}
                                </option>
                            </select>
                        </label>
                        <label class="ml10">
                            Филиал
                            <select v-on:change="load" :disabled="isLoading" v-model="filter.filiation" class="form-control input-sm">
                                <option value="">Не выбран</option>
                                <option v-for="(filial, index) in filiations" v-bind:key="index" :value="filial.id">
                                    {{filial.name}}
                                </option>
                            </select>
                        </label>
                    </div>
                </div>
                <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Филиал</th>
                            <th>Направление</th>
                            <th>Дни</th>
                            <th>Инструктор</th>
                            <th>Дата</th>
                            <th>Сгенерирована</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(group, index) in groups" v-bind:key="index">
                            <td>{{group.id}}</td>
                            <td>
                                <router-link :to="{name: 'schedule-group-edit', params: {id: group.id}}">
                                    {{group.filiationId ? filiations.find(filiation => filiation.id === group.filiationId).name : 'Нет'}}
                                </router-link>
                            </td>
                            <td>
                                {{getDirectionName(group.directionId)}}
                            </td>
                            <td>
                                <label class="label label-info mr5" v-for="day in group.days.filter(day => day.status === true)" v-bind:key="`day-${day.id}`">
                                    {{day.getWeekName()}} - {{day.start}}
                                </label>
                            </td>
                            <td>
                                {{getTrainerName(group.trainerId)}}
                            </td>
                            <td>
                                с {{group.start | dateFormat('dd.mm.yyyy')}}
                                по {{group.end | dateFormat('dd.mm.yyyy')}}
                            </td>
                            <td>
                                <span class="label" :class="{'label-success': group.isGenerated === true, 'label-danger': group.isGenerated === false}">
                                    {{group.isGenerated === true ? 'Да' : 'Нет'}}
                                </span>
                            </td>
                            <td>
                                <span class="label" :class="{'label-success': group.status === true, 'label-danger': group.status === false}">
                                    {{group.status === true ? 'Активна' : 'Закрыта'}}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
    import Group from "../../../models/Group";
    import Filiation from "../../../models/Filliation";
    import Trainer from "../../../models/Trainer";
    import Direction from "../../../models/Direction";
    import FitnessRoom from "../../../models/FitnessRoom";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../../data/Paginator'),
            PerPager: () => import('../../data/PerPager'),
        },
        async beforeMount() {
            await this.loadData();
            this.load();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.loadData();
            this.load();
        },
        data() {
            return {
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                rooms: [],
                filiations: [],
                directions: [],
                trainers: [],
                groups: [],
                filter: {
                    filiation: '',
                    trainer: '',
                    direction: '',
                },
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async loadData() {
                let roomsResponse, filiationResponse, directionsResponse, trainersResponse;

                [roomsResponse, directionsResponse, trainersResponse, filiationResponse] = await Promise.all([
                    FitnessRoom.getList(1, 999),
                    Direction.getList(1, 999),
                    Trainer.getList(1, 999),
                    Filiation.getList(1, 999),
                ]);

                this.filiations = filiationResponse.data;
                this.rooms = roomsResponse.data;
                this.directions = directionsResponse.data;
                this.trainers = trainersResponse.data;
            },
            async load() {
                this.isLoading = true;

                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();
                let groupsResponse = await Group.getList(page, perPage, '-id', ['days'], this.filter);

                this.setData(groupsResponse.data, groupsResponse.headers);

                this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['schedule-group-list']) {
                    return this.$store.state.template.perPages['schedule-group-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'schedule-group-list', value: value})
            },
            setData(groups, headers) {
                this.groups = groups;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            },
            getDirectionName(id) {
                let direction = this.directions.find(direction => direction.id === id);
                if (!direction) {
                    return '---';
                }
                return direction.name;
            },
            getTrainerName(id) {
                let trainer = this.trainers.find(trainer => trainer.id === id);
                if (!trainer) {
                    return '---';
                }
                return trainer.fullName;
            },
        },
        metaInfo() {
            return {
                title: 'Группы - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
